import { WizardStepT } from "../graphql/generated/graphql";

export const WIZARD_STEP_PATH = {
  [WizardStepT.FirstT]: "/wizard",
  [WizardStepT.SuggestionGeneratorT]: "/wizard/suggestion-generator",
  [WizardStepT.ImageSelectionT]: "/wizard/image-selection",
  [WizardStepT.TextSelectionT]: "/wizard/text-selection",
  [WizardStepT.CheckT]: "/wizard/check",
  [WizardStepT.FinishT]: "/wizard/finish",

  // meta campaign steps
  [WizardStepT.MetaFirstT]: "/wizard/meta-preview",
  [WizardStepT.MetaPageLinkingT]: "/wizard/meta-page-linking",
  [WizardStepT.MetaProductsSelectionT]: "/wizard/meta-products",
  [WizardStepT.MetaTextSelectionT]: "/wizard/meta-adtext",
  [WizardStepT.MetaBudgetT]: "/wizard/meta-budget",
  [WizardStepT.MetaFinishT]: "/wizard/meta-finish",

  // dashboard is same for both campaigns
  [WizardStepT.DashboardT]: "/dashboard",
};
